"use client";
import _extends from '@babel/runtime/helpers/extends';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import * as React from 'react';
import { Box } from '../../Box/Box.web.js';
import { Heading } from '../../Heading/Heading.web.js';
import { IconButton } from '../../IconButton/IconButton.web.js';
import { Button } from '../../Button/Button.web.js';
import { ErrorMessage } from '../../ErrorMessage/ErrorMessage.web.js';
import { ContentText } from '../../ContentText/ContentText.web.js';
import { IconCross } from '../../icons/ui_control/IconCross.web.js';
import { useTheme } from '../../utils/theming/useTheme.js';
import { px2rem } from '../../utils/helpers/style.js';
import { spacing } from '../../constants/spacing.js';

var _excluded = ["children", "labels", "onClose", "disableSubmit", "onSubmit", "submitCloses", "error", "color"];
var NPSForm = function NPSForm(_ref) {
  var children = _ref.children,
    labels = _ref.labels,
    onClose = _ref.onClose,
    disableSubmit = _ref.disableSubmit,
    onSubmit = _ref.onSubmit,
    submitCloses = _ref.submitCloses,
    error = _ref.error,
    color = _ref.color,
    props = _objectWithoutProperties(_ref, _excluded);
  var theme = useTheme();
  return /*#__PURE__*/React.createElement(Box, _extends({
    "data-testid": "elemental-NPS",
    backgroundColor: theme.nps.web.background,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    minWidth: {
      "default": 'unset',
      m: px2rem(600)
    },
    maxWidth: {
      "default": 'unset',
      m: px2rem(600)
    },
    position: "relative",
    p: spacing.xs,
    tag: "form"
  }, props), onClose && /*#__PURE__*/React.createElement(IconButton, {
    "data-testid": "elemental-NPS-close",
    icon: IconCross,
    onClick: onClose,
    color: theme.nps.web.closeButtonBackground,
    status: "plain",
    invert: true,
    position: "absolute",
    right: "0",
    top: "0"
  }), /*#__PURE__*/React.createElement(Heading, {
    level: 4,
    contentHeading: true,
    "data-testid": "elemental-NPS-Heading"
  }, labels.heading), children, onSubmit && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Button, {
    "data-testid": "elemental-NPS-submit",
    mt: spacing.s,
    disabled: disableSubmit,
    onClick: onSubmit,
    "aria-describedby": error ? 'elemental-NPS-submit-error' : undefined,
    color: color || theme.nps.web.color
  }, submitCloses ? labels.close : labels.submit), /*#__PURE__*/React.createElement(ErrorMessage, {
    active: Boolean(error),
    id: "elemental-NPS-submit-error"
  }, /*#__PURE__*/React.createElement(ContentText, null, labels.error))));
};

export { NPSForm };
